import { render, staticRenderFns } from "./ArchivesStatisticst.vue?vue&type=template&id=4cb8a0e0&scoped=true&"
import script from "./ArchivesStatisticst.vue?vue&type=script&lang=js&"
export * from "./ArchivesStatisticst.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesStatisticst.vue?vue&type=style&index=0&id=4cb8a0e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb8a0e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cb8a0e0')) {
      api.createRecord('4cb8a0e0', component.options)
    } else {
      api.reload('4cb8a0e0', component.options)
    }
    module.hot.accept("./ArchivesStatisticst.vue?vue&type=template&id=4cb8a0e0&scoped=true&", function () {
      api.rerender('4cb8a0e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/report/ArchivesStatisticst.vue"
export default component.exports